import type { ComponentType } from "react";
import { RecrutaCISDeepDive } from "./recrutacis";
import { OpenClawDeepDive } from "./openclaw";

export const DEEP_DIVES: Record<string, ComponentType> = {
  recrutacis: RecrutaCISDeepDive,
  openclaw: OpenClawDeepDive,
};
